// if number of list items is 4, add class to get 4 in a row (else will break after 3)

const careerPhasesListsAll = document.querySelectorAll(".careerphasesblock ul");

careerPhasesListsAll.forEach(careerPhasesList => {
	const listLength = careerPhasesList.querySelectorAll("li").length;
	if (listLength === 4) {
		careerPhasesList.classList.add("four");
	}
});